import { Component, computed, Input, Signal } from '@angular/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@Component({
  selector: 'fgbcl-wallet-text-with-badge',
  standalone: true,
  imports: [FGBSharedModule],
  templateUrl: './wallet-text-with-badge.component.html',
  styleUrl: './wallet-text-with-badge.component.scss',
})
export class WalletTextWithBadgeComponent {
  @Input({ required: true }) count: Signal<number>;
  hasUnredeemedItems: Signal<boolean> = computed(() => this.count() > 0);
  countDisplayText: Signal<string> = computed(() => {
    if (this.count() > 99) {
      return '99+';
    } else {
      return this.count().toString();
    }
  });
}
